<div ngbDropdown class="hide-pdf-print">
    <button type="button" class="btn btn-outline-primary" ngbDropdownToggle>
        <span>{{title}}</span><ng-icon name="IonDownloadOutline" size="16px" strokeWidth="46px"></ng-icon>
    </button>
    <div ngbDropdownMenu aria-labelledby="dropdown">
        <ng-content></ng-content>
    </div>
</div>